import { useState, useEffect, useRef } from 'react';

export const useEmailSelection = (emails) => {
	const [selectedEmailId, setSelectedEmailId] = useState(null);
	const emailIdsRef = useRef(new Set());

	// Keep a stable Set of current email IDs to avoid re-selecting on array reference changes
	useEffect(() => {
		emailIdsRef.current = new Set(emails.map((e) => e.id));
	}, [emails]);

	// Auto-select first email only when selection is missing or removed from list
	useEffect(() => {
		if (emails.length === 0) return;
		if (selectedEmailId && emailIdsRef.current.has(selectedEmailId)) return;
		setSelectedEmailId(emails[0].id);
	}, [emails, selectedEmailId]);

	const selectedEmail = emails.find((e) => e.id === selectedEmailId);

	return {
		selectedEmailId,
		setSelectedEmailId,
		selectedEmail,
	};
};
